module.exports = __webpack_public_path__ + "img/zh-reward1.c317ac25.jpg";